/**
 * Route state key for operations card shipment filters
 */
export const SHIPMENT_FILTERS_STATE_KEY = 'shipmentFilters';

export type ShipmentFilter = {
  filterById: string;
  type: string;
  filterValue: string;
  criterionOperatorValue: string;
  criterionArgumentValue?: unknown;
};
